import type { MouseEvent } from 'react'

export function handleDocsContentClick(event: MouseEvent<HTMLElement>, navigate: (to: string) => void) {
  const target = event.target
  if (!(target instanceof Element)) {
    return
  }

  const anchor = target.closest('a')
  if (!anchor) {
    return
  }

  const href = anchor.getAttribute('href')
  if (!href?.startsWith('/docs')) {
    return
  }

  event.preventDefault()
  navigate(href)
}
